/**
 * PrimeVue Slider — aligned to RedisiginProductPage `146:12440` / `146:12463`
 */
export const root = {
  transitionDuration: '{transition.duration}',
}

export const track = {
  background: 'rgba(26, 33, 51, 0.1)',
  borderRadius: '999px',
  size: '2px',
}

export const range = {
  background: '#1a2133',
}

export const handle = {
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  background: 'transparent',
  hoverBackground: 'transparent',
  content: {
    background: '#1a2133',
    borderRadius: '50%',
    hoverBackground: '#1a2133',
    width: '12px',
    height: '12px',
    shadow: 'none',
  },
  focusRing: {
    width: '1px',
    style: 'solid',
    color: 'rgba(26, 33, 51, 0.2)',
    offset: '0',
    shadow: '0 0 0 1px rgba(26, 33, 51, 0.2)',
  },
}

export const colorScheme = {
  light: {
    handle: {
      content: {
        background: '#1a2133',
      },
    },
  },
  dark: {
    handle: {
      content: {
        background: '#1a2133',
      },
    },
  },
}

export default {
  root,
  track,
  range,
  handle,
  colorScheme,
}
